

































































































import mixins from 'vue-typed-mixins';
import SurveyUtils, {
  SurveyParticipation,
  SurveyState,
} from '@/utils/SurveyUtils';
import cloneDeep from 'lodash.clonedeep';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => SurveyParticipation,
    },
  },
  computed: {
    states() {
      return ['parent', 'inactive',];
    },
    submissionstatesOptions(): any {
      return this.submissionstates?.map((state) => ({
        text: `${this.$translate(state.name)} (${state.category})`,
        value: state,
      }));
    },
  },
  data(): {
    menu: {
      opendate: boolean;
      startdate: boolean;
      submitteddate: boolean;
      completeddate: boolean;
      createddate: boolean;
    };
    submissionstates?: SurveyState[];
  } {
    return {
      menu: {
        opendate: false,
        startdate: false,
        submitteddate: false,
        completeddate: false,
        createddate: false,
      },
      submissionstates: undefined,
    };
  },
  async mounted() {
    try {
      this.submissionstates = await SurveyUtils.api.surveyState.list({
        surveyid: this.value.survey.id as number,
      });

      this.value.submissionstate = this.submissionstates?.find(
        (state) => state.key === this.value.submissionstate?.key
      ) as SurveyState;
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },
});
